const es = {
    '/': {
        title: '{brand} | Apuestas Deportivas, Casino en Vivo & Retiros Instantáneos',
        description: 'Tragamonedas, casino en vivo y apuestas deportivas en {brand}. Casino crypto con retiros instantáneos, juegos demostrablemente justos & soporte 24/7.'
    },
    '/casino': {
        title: 'Casino en Línea | Tragamonedas, Blackjack & Dealers en Vivo | {brand}',
        description: 'Tragamonedas, blackjack, ruleta & dealers en vivo en {brand}. Cientos de juegos, depósitos crypto rápidos & retiros instantáneos disponibles 24/7.'
    },
    '/sports': {
        title: 'Apuestas Deportivas en Línea | Apuestas Crypto & Cuotas | {brand}',
        description: 'Apuesta en deportes en {brand}. Cuotas competitivas en fútbol, baloncesto & más. Apuestas en vivo, apuestas crypto seguras & pagos rápidos.'
    },
    '/livecasino': {
        title: 'Casino en Vivo | Blackjack, Ruleta & Dealers en Directo | {brand}',
        description: 'Blackjack, ruleta & juegos de casino en vivo en {brand}. Dealers reales, streaming en HD & una amplia selección de mesas disponibles 24/7.'
    },
    '/slots': {
        title: 'Tragamonedas en Línea | Gran Variedad de Slots de Casino | {brand}',
        description: 'Una enorme colección de tragamonedas en {brand}. Máquinas clásicas, video slots & progresivas, todas jugables con crypto.'
    },
    '/vip': {
        title: 'Programa VIP | Recompensas Exclusivas y Beneficios | {brand}',
        description: 'El programa VIP de {brand}: recompensas exclusivas, bonificaciones personalizadas y soporte prioritario. Beneficios diseñados para jugadores leales.'
    },
    '/welcome-offer': {
        title: 'Bono de Bienvenida | Casino Crypto | {brand}',
        description: 'Descubre el bono de bienvenida de {brand}. Empieza con crypto y disfruta de beneficios exclusivos para nuevos jugadores.'
    },
    '/referral': {
        title: 'Programa de Referidos | Gana Recompensas | {brand}',
        description: 'Invita amigos a {brand} y gana recompensas cuando se unan y cumplan los requisitos. Comparte tu enlace y comienza a ganar.'
    },
    '/promotion-page': {
        title: 'Promociones | Bonos y Ofertas Especiales | {brand}',
        description: 'Explora todas las promociones activas en {brand}. Bonos, giros gratis y ofertas especiales para jugadores crypto.'
    },
    '/hotslots': {
        title: 'Slots Populares | Tragamonedas Más Jugadas | {brand}',
        description: 'Juega las tragamonedas más populares en {brand}. Los slots más calientes disponibles con crypto.'
    },
    '/newgames': {
        title: 'Juegos Nuevos | Últimos Juegos de Casino | {brand}',
        description: 'Descubre los últimos juegos de casino en {brand}. Nuevas tragamonedas, juegos en vivo y más, actualizado regularmente.'
    },
    '/populargames': {
        title: 'Juegos Populares | Los Más Jugados en el Casino | {brand}',
        description: 'Los juegos de casino más populares en {brand}. Desde tragamonedas hasta dealers en vivo, todos jugables con crypto.'
    },
    '/gameshows': {
        title: 'Game Shows | Casino con Shows en Vivo | {brand}',
        description: 'Disfruta los mejores game shows en vivo en {brand}. Presentadores reales, juegos únicos y grandes premios en tiempo real.'
    },
    '/table_games': {
        title: 'Juegos de Mesa | Blackjack, Ruleta & Baccarat | {brand}',
        description: 'Juega blackjack, ruleta, baccarat y más juegos de mesa en {brand}. Todo disponible con crypto.'
    },
    '/hotlive': {
        title: 'Casino en Vivo Popular | Juegos en Vivo Más Jugados | {brand}',
        description: 'Los juegos de casino en vivo más populares en {brand}. Juega con dealers reales en tiempo real.'
    },
    '/featurebuyin': {
        title: 'Slots con Compra de Bonus | Feature Buy-in | {brand}',
        description: 'Juega tragamonedas con opción de comprar el bonus en {brand}. Accede directamente al bonus round sin esperar.'
    },
    '/originals': {
        title: 'Juegos de Casino Originales | Títulos Exclusivos | {brand}',
        description: 'Juega juegos originales exclusivos en {brand}. Títulos únicos que no encontrarás en ningún otro lugar, desarrollados internamente para una experiencia de casino incomparable.'
    },
    '/providers': {
        title: 'Proveedores de Juegos | Estudios Asociados & Software | {brand}',
        description: 'Explora todos los proveedores de juegos en {brand}. Nos asociamos con los mejores estudios para ofrecerte una biblioteca crypto de alta calidad y gran variedad.'
    },
    '/about-us': {
        title: 'Sobre Nosotros | Conoce más sobre {brand}',
        description: 'Conoce {brand}, un casino crypto & sportsbook líder. Comprometidos con el juego seguro, justo & emocionante con retiros instantáneos en crypto.'
    },
    '/affiliate': {
        title: 'Programa de Afiliados | Gana Crypto con {brand}',
        description: 'Asóciate con {brand} & gana comisiones promocionando nuestro casino crypto. Tarifas competitivas, seguimiento en tiempo real & soporte dedicado para afiliados.'
    },
    '/faq': {
        title: 'FAQ | Preguntas Frecuentes | {brand}',
        description: 'Encuentra respuestas a preguntas frecuentes sobre {brand}. Consulta nuestras FAQ sobre cuentas, pagos, bonos & juegos de casino.'
    },
    '/aml-policy': {
        title: 'Política AML | Prevención de Lavado de Dinero en {brand}',
        description: 'La política AML de {brand} garantiza un entorno seguro y confiable. Conoce nuestras medidas para prevenir actividades ilícitas en nuestra plataforma.'
    },
    '/bonus-terms': {
        title: 'Términos y Condiciones de Bonos | Promociones de {brand}',
        description: 'Lee las reglas de bonos & promociones de {brand}. Aprende cómo reclamar, usar & retirar ganancias de bonos en nuestra plataforma.'
    },
    '/complaints-and-arbitration': {
        title: 'Quejas y Arbitraje | Soporte para Jugadores en {brand}',
        description: 'Conoce el proceso de resolución de quejas & disputas de {brand}. Garantizamos un trato justo y resolvemos los problemas de los jugadores de forma rápida y transparente.'
    },
    '/fairness': {
        title: 'Juegos Demostrablemente Justos | Garantía de Equidad en {brand}',
        description: '{brand} utiliza tecnología demostrablemente justa para garantizar que cada resultado sea verificable, transparente & completamente aleatorio.'
    },
    '/kyc-policy': {
        title: 'Política KYC | Verificación de Identidad en {brand}',
        description: 'La política KYC de {brand} describe nuestro proceso de verificación de identidad. Descubre cómo protegemos a los jugadores y mantenemos un entorno de juego seguro.'
    },
    '/payment-policy': {
        title: 'Política de Pagos | Depósitos & Retiros en Crypto | {brand}',
        description: '{brand} acepta depósitos & retiros en crypto. Lee nuestra política de pagos para conocer límites, monedas aceptadas & tiempos de procesamiento.'
    },
    '/privacy-policy': {
        title: 'Política de Privacidad | Protección de Datos en {brand}',
        description: 'La política de privacidad de {brand}. Descubre cómo recopilamos, usamos & protegemos tus datos personales en nuestra plataforma de casino crypto.'
    },
    '/responsible-gaming': {
        title: 'Juego Responsable | Juega de Forma Segura en {brand}',
        description: '{brand} está comprometido con el juego responsable. Accede a herramientas & recursos para gestionar tus hábitos de juego y jugar de forma segura.'
    },
    '/terms-of-service': {
        title: 'Términos de Servicio | {brand}',
        description: 'Revisa los términos & condiciones que rigen el uso de {brand}. Comprende tus derechos y responsabilidades como jugador.'
    },
    '/terms-sports': {
        title: 'Términos y Condiciones de Apuestas Deportivas | {brand}',
        description: 'Los términos & condiciones de apuestas deportivas de {brand}. Reglas para realizar apuestas, cobrar ganancias & usar el sportsbook en nuestra plataforma.'
    }
};
export default es;
